/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Ai_BodyInputs */

const tr_mesafeli_s11_ai_body = /** @type {(inputs: Mesafeli_S11_Ai_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI modeli sağlayıcıları.`)
};

const en_mesafeli_s11_ai_body = /** @type {(inputs: Mesafeli_S11_Ai_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI model providers.`)
};

const de_mesafeli_s11_ai_body = /** @type {(inputs: Mesafeli_S11_Ai_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter von AI-Modellen.`)
};

const ru_mesafeli_s11_ai_body = /** @type {(inputs: Mesafeli_S11_Ai_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщики моделей AI.`)
};

/**
* | output |
* | --- |
* | "AI model providers." |
*
* @param {Mesafeli_S11_Ai_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_ai_body = /** @type {((inputs?: Mesafeli_S11_Ai_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Ai_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_ai_body(inputs)
	if (locale === "de") return de_mesafeli_s11_ai_body(inputs)
	if (locale === "ru") return ru_mesafeli_s11_ai_body(inputs)
	return tr_mesafeli_s11_ai_body(inputs)
});